import { TeamInfoModal } from "@meitu/xdesign-widgets/dist/teamInfo";
import { UserInfoType } from "@meitu/xdesign-widgets/dist/types/userInfo";
import { openVipModal } from "@/utils/login";
import { statTrack } from "@/utils/mtstat";
import React from "react";

interface TeamInfoProps {
  userInfo?: UserInfoType;
}

function TeamInfo({ userInfo }: TeamInfoProps) {
  const handleOpenVip = (params: Record<string, any> = {}) => {
    openVipModal(params);
  };

  return (
    <>
      <TeamInfoModal
        uid={userInfo?.id || 0}
        onChange={() => {
          window.location.reload();
        }}
        onOpenVipModal={(params) => {
          handleOpenVip(params);
        }}
        onTrack={statTrack}
      />
    </>
  );
}

export default React.memo(TeamInfo);
